var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmoji5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3244 13.6752C23.2498 7.97318 19.3776 2.6006 13.6756 1.6752C7.97357 0.749803 2.60099 4.62201 1.67559 10.324C0.750185 16.026 4.6224 21.3986 10.3244 22.324C16.0264 23.2494 21.399 19.3772 22.3244 13.6752Z",
    fill: "#FFD05D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4711 3.0918C18.5127 4.71795 19.1167 6.65126 19.1167 8.72567C19.1167 14.5023 14.4339 19.185 8.65733 19.185C6.65114 19.185 4.7771 18.6197 3.18506 17.6405C5.04387 20.5424 8.29681 22.4659 11.9989 22.4659C17.7754 22.4659 22.4582 17.783 22.4582 12.0066C22.4583 8.23618 20.463 4.93221 17.4711 3.0918Z",
    fill: "#FDC453"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96007 13.1187C2.96007 7.75548 7.30782 3.40773 12.671 3.40773C15.8059 3.40773 18.5932 4.89363 20.3687 7.19899C18.6919 4.28793 15.5489 2.32812 11.9482 2.32812C6.58506 2.32812 2.2373 6.67587 2.2373 12.0391C2.2373 14.2673 2.98842 16.32 4.25049 17.9587C3.42968 16.5337 2.96007 14.881 2.96007 13.1187Z",
    fill: "#FFD77F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4443 17.0303C16.1924 14.7977 14.2987 13.0625 11.9988 13.0625C9.69894 13.0625 7.80515 14.7977 7.55322 17.0303H16.4443Z",
    fill: "#695342"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55322 17.0142C7.55322 17.0142 11.3041 14.2488 16.4443 17.0142H7.55322Z",
    fill: "#F06669"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35463 12.18C6.22259 12.18 6.09203 12.1213 6.00466 12.0091C5.85421 11.8159 5.8887 11.5374 6.08197 11.3868L7.59044 10.2115L6.03116 9.29434C5.8201 9.17015 5.74966 8.89835 5.87372 8.68741C5.99803 8.47635 6.26971 8.40591 6.48065 8.52997L8.60243 9.77794C8.72907 9.85242 8.81055 9.98471 8.82012 10.1312C8.82969 10.2777 8.76601 10.4196 8.65017 10.5098L6.62692 12.0861C6.54593 12.1494 6.44985 12.18 6.35463 12.18Z",
    fill: "#303030"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6425 12.1797C17.5472 12.1797 17.4512 12.1492 17.3703 12.0861L15.3472 10.5098C15.2313 10.4194 15.1676 10.2777 15.1772 10.1312C15.1868 9.98468 15.2683 9.85239 15.3949 9.77791L17.5166 8.52995C17.7273 8.40601 17.9992 8.4762 18.1235 8.68738C18.2476 8.89832 18.1772 9.17012 17.9661 9.29431L16.4068 10.2114L17.9152 11.3868C18.1084 11.5372 18.143 11.8159 17.9926 12.009C17.9049 12.1209 17.7744 12.1797 17.6425 12.1797Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji5);
export default __webpack_public_path__ + "static/media/Emoji5.c566bab8db72918e256cacb0f6a90fdc.svg";
export { ForwardRef as ReactComponent };